import { Paper, Box, Stack } from "@mui/material";
import NationalBenchMarks from "./national-benchmarks";
import HistoricalGraphs from "./historical-graphs";
import { useState } from "react";

const SAVED_INPUT_LOCAL_STORAGE_KEY = "marketMonitorInputValues";

export default function MarketMonitor() {
  const localStorageValue = localStorage.getItem(SAVED_INPUT_LOCAL_STORAGE_KEY);
  const [savedInputValues, setSavedInputValues] = useState(
    localStorageValue ? JSON.parse(localStorageValue) : {}
  );
  const handleInputUpdate = ({ key, value }) => {
    const newInputValues = { ...savedInputValues, [key]: value };
    setSavedInputValues(newInputValues);
    localStorage.setItem(
      SAVED_INPUT_LOCAL_STORAGE_KEY,
      JSON.stringify(newInputValues)
    );
  };
  return (
    <Stack direction="row" justifyContent="center" width="100%" spacing={2} py={2}>
      <Paper component={Box} height="100%" width="500px">
        <NationalBenchMarks
          handleInputUpdate={handleInputUpdate}
          savedInputValues={savedInputValues}
        />
      </Paper>

      <Paper component={Box} height="100%" width="500px">
        <HistoricalGraphs
          handleInputUpdate={handleInputUpdate}
          savedInputValues={savedInputValues}
        />
      </Paper>
    </Stack>
  )
}
